var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcast01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6797 29.2891C11.6797 31.2737 10.0706 32.8828 8.08594 32.8828C6.10129 32.8828 4.49219 31.2737 4.49219 29.2891C4.49219 27.3044 6.10129 25.6953 8.08594 25.6953C10.0706 25.6953 11.6797 27.3044 11.6797 29.2891Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2734 40.0703H0.898438C0.898438 37.0929 3.31164 34.6797 6.28906 34.6797H9.88281C12.8602 34.6797 15.2734 37.0929 15.2734 40.0703Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5937 29.2891C26.5937 31.2737 24.9846 32.8828 23 32.8828C21.0154 32.8828 19.4062 31.2737 19.4062 29.2891C19.4062 27.3044 21.0154 25.6953 23 25.6953C24.9846 25.6953 26.5937 27.3044 26.5937 29.2891Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5078 29.2891C41.5078 31.2737 39.8987 32.8828 37.9141 32.8828C35.9294 32.8828 34.3203 31.2737 34.3203 29.2891C34.3203 27.3044 35.9294 25.6953 37.9141 25.6953C39.8987 25.6953 41.5078 27.3044 41.5078 29.2891Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1016 40.0703H30.7266C30.7266 37.0929 33.1398 34.6797 36.1172 34.6797H39.7109C42.6884 34.6797 45.1016 37.0929 45.1016 40.0703Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72568 10.5224L5.78236 14.4594L1.43752 15.091L4.58115 18.1555L3.83904 22.4824L7.72568 20.4394C9.18564 21.2075 10.1937 21.7367 11.6114 22.4824L10.8693 18.1555L14.0138 15.091L9.669 14.4594L7.72568 10.5224Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2743 10.5224L36.331 14.4594L31.9861 15.091L35.1307 18.1555L34.3886 22.4824L38.2743 20.4394C39.7352 21.2075 40.7432 21.7367 42.1609 22.4824L41.4188 18.1555L44.5625 15.091L40.2176 14.4594L38.2743 10.5224Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.92978L20.4969 11.0015L14.9006 11.8145L18.9498 15.7623L17.9939 21.3362L23 18.7047L28.0061 21.3362L27.0501 15.7623L31.0994 11.8145L25.503 11.0015L23 5.92978Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.957 40.0703H15.2734C15.2734 37.0929 17.6866 34.6797 20.6641 34.6797H25.3359C28.3134 34.6797 30.7266 37.0929 30.7266 40.0703H27.043",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1016 40.0703C22.1016 39.5742 22.5038 39.1719 23 39.1719C23.4962 39.1719 23.8984 39.5742 23.8984 40.0703C23.8984 40.5664 23.4962 40.9688 23 40.9688C22.5038 40.9688 22.1016 40.5664 22.1016 40.0703Z",
    fill: "#457ABD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast01);
export default __webpack_public_path__ + "static/media/Broadcast01.c9fef95eb4493b4e0b18b1ed02b21e9a.svg";
export { ForwardRef as ReactComponent };